var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(" Sessione scaduta ")]),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.logout}},[_vm._v(" Effettua nuovo login ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }